import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_334: DocMigration = {
  maxSchemaVersion: "0.0.334",
  description:
    "Replicates the state of showDormerGableWindowVerticalDims and showRoofGableWindowVerticalDims to " +
    "showDormerGableWindowReportedName and showRoofGableWindowReportedName respectively",
  apply(json: any) {
    for (const id in json.settings) {
      const setting = json.settings[id];
      if (setting.type === "PLAN_SETTINGS") {
        if (setting.showDormerGableWindowVerticalDims !== undefined) {
          setting.showDormerGableWindowReportedName = setting.showDormerGableWindowVerticalDims;
        }
        if (setting.showRoofGableWindowVerticalDims !== undefined) {
          setting.showRoofGableWindowReportedName = setting.showRoofGableWindowVerticalDims;
        }
      }
    }
    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const elevationSettings = roof.roofElevationPlanSettings;
      if (elevationSettings?.showDormerGableWindowVerticalDims !== undefined) {
        elevationSettings.showDormerGableWindowReportedName = elevationSettings.showDormerGableWindowVerticalDims;
      }
      if (elevationSettings?.showRoofGableWindowVerticalDims !== undefined) {
        elevationSettings.showRoofGableWindowReportedName = elevationSettings.showRoofGableWindowVerticalDims;
      }
    }
    for (const id in json.dormers) {
      const dormer = json.dormers[id];
      const elevationSettings = dormer.dormerElevationPlanSettings;
      if (elevationSettings?.showDormerGableWindowVerticalDims !== undefined) {
        elevationSettings.showDormerGableWindowReportedName = elevationSettings.showDormerGableWindowVerticalDims;
      }
    }
    return json;
  },
};

export default migration_0_0_334;
